<template>
  <div v-if="submitted" class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <a
      v-if="value.answer.attachment"
      :href="value.answer.attachment.url"
      target="_blank" :class="themes.candidate.light.link"
    >View attachment</a>
    <span v-else>No attachment provided</span>
  </div>
  <div v-else class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <v-text-field
      placeholder="Click to select a file"
      prepend-icon="mdi-file-document"
      :value="filename"
      @click="$refs.attachment.click()"
      :disabled="submitted"
      :color="themes.candidate.light.input"
      :clearable="value.question.optional"
      @click:clear="removeFile"
      hint="Only JPEG and PNG images or PDF documents are accepted" persistent-hint
    />
    <input
      type="file" name="attachment" ref="attachment"
      style="display: none"
      @change="setFile"
    />
    <a
      v-if="value.answer.attachment"
      :href="value.answer.attachment.url"
      target="_blank" :class="themes.candidate.light.link"
    >View attachment</a>
  </div>
</template>

<script>
// Vue Component
export default {
  props: { value: Object, submitted: Boolean },
  computed: {
    filename() {
      if (this.value.answer && this.value.answer.attachment) {
        const fullUrl = this.value.answer.attachment.url
        return fullUrl
          .split('/')
          .pop()
          .split('?')[0]
      } else {
        return 'No file selected'
      }
    }
  },
  methods: {
    setFile() {
      const formData = new FormData()
      formData.append('answer[answerSetId]', this.value.answer.answerSetId)
      formData.append('answer[questionId]', this.value.answer.questionId)
      formData.append('answer[attachment]', this.$refs.attachment.files[0])

      this.$emit('saving')
      if (this.value.answer.id) {
        this.$http
          .patch(`candidate/answers/${this.value.answer.id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            this.value.answer = response.data
            this.$emit('saved')
          })
      } else {
        this.$http
          .post('candidate/answers', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            this.value.answer = response.data
            this.$emit('saved')
          })
      }
    },
    removeFile() {
      this.$emit('saving')
      this.$http
        .delete(`candidate/answers/${this.value.answer.id}`)
        .then(response => {
          this.value.answer = null
          this.$emit('saved')
        })
    }
  }
}
</script>
